/**
 * @file Defines the {@link GAME_DEVICES} constant
 * @author Joe Thompson <joe.thompson@1x2gaming.com>
 */

/**
 * Game size.
 * @type {object}
 * @constant
 * @default
 * @property {number} desktop - Class name for desktop styling.
 * @property {number} mobile  - Class name for mobile styling.
 */
const GAME_DEVICES = {

    desktop: 'dt',
    mobile:  'mb'

}

export { GAME_DEVICES }
